import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { listMissingVariables } from "../../../utils/index.js";
import { visuallyHidden } from "@mui/utils";
import { Text } from "@nxt-costco-com/forge-components";
import { SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
import { CostcoBox } from "../../Util/CostcoBox.js";
import { COMPONENT_NAME } from "./constants.js";
const TextWithSuffix = ({
  text,
  textSx = {},
  textVariant = "t6",
  suffixText,
  suffixVariant = textVariant,
  suffixTextSx = {},
  uniqueId
}) => {
  const missingProps = listMissingVariables({
    text,
    uniqueId
  });
  if ((missingProps == null ? void 0 : missingProps.length) > 0) {
    console.error(`Missing props: ${missingProps}}`);
    return null;
  }
  return /* @__PURE__ */ jsxs(
    CostcoBox,
    {
      component: "span",
      sx: { alignItems: "center", display: "inline-flex", gap: SpaceXxs },
      children: [
        text && /* @__PURE__ */ jsx(
          Text,
          {
            component: "span",
            sx: textSx,
            uniqueId,
            variant: textVariant,
            children: text
          }
        ),
        suffixText && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(CostcoBox, { component: "span", sx: visuallyHidden, children: " " }),
          /* @__PURE__ */ jsx(
            Text,
            {
              component: "span",
              sx: suffixTextSx,
              uniqueId: `${uniqueId}_suffix`,
              variant: suffixVariant,
              children: suffixText
            }
          )
        ] })
      ]
    }
  );
};
const StockStatus = ({
  Adornment,
  containerSx = {},
  statusText,
  statusTextSx = {},
  suffixText,
  suffixTextSx = {},
  textVariant = "t6",
  suffixVariant = textVariant,
  visuallyHiddenText,
  uniqueId,
  textBlocks = []
}) => {
  const missingProps = listMissingVariables({
    statusText,
    uniqueId
  });
  if ((missingProps == null ? void 0 : missingProps.length) > 0) {
    console.error(`Missing props: ${missingProps}}`);
    return null;
  }
  return /* @__PURE__ */ jsxs(
    CostcoBox,
    {
      sx: {
        alignItems: "flex-start",
        display: "flex",
        flexDirection: "column",
        ...containerSx
      },
      component: "span",
      "data-testid": `${COMPONENT_NAME}_${uniqueId}`,
      children: [
        /* @__PURE__ */ jsxs(
          CostcoBox,
          {
            sx: {
              alignItems: "center",
              display: "inline-flex",
              gap: SpaceXxs
            },
            component: "span",
            children: [
              /* @__PURE__ */ jsx(
                TextWithSuffix,
                {
                  suffixText,
                  suffixTextSx,
                  suffixVariant,
                  text: statusText,
                  textSx: statusTextSx,
                  textVariant,
                  uniqueId: "stockStatusText"
                }
              ),
              visuallyHiddenText && /* @__PURE__ */ jsxs(CostcoBox, { component: "span", sx: visuallyHidden, children: [
                visuallyHiddenText,
                " "
              ] }),
              Adornment && /* @__PURE__ */ jsx(Fragment, { children: Adornment })
            ]
          }
        ),
        textBlocks.length > 0 && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(CostcoBox, { component: "span", sx: visuallyHidden, children: " " }),
          textBlocks.map((block, index) => /* @__PURE__ */ jsx(
            TextWithSuffix,
            {
              suffixText: block == null ? void 0 : block.suffixText,
              suffixTextSx: block == null ? void 0 : block.suffixTextSx,
              suffixVariant: block == null ? void 0 : block.suffixVariant,
              text: block == null ? void 0 : block.text,
              textSx: block == null ? void 0 : block.textSx,
              textVariant: block == null ? void 0 : block.textVariant,
              uniqueId: block == null ? void 0 : block.uniqueId
            },
            index
          ))
        ] })
      ]
    }
  );
};
export {
  StockStatus
};
